import { webApiEndpoints } from '../config';
import { mapper } from '../helpers/mapper.helper';
import secureHelper from '../helpers/secure.helper';
import util from '../helpers/util.helper';
import { UserAccessType, UserAuth, UserCredentials, ResourceType, UserNotification, AppRequestType, AppCategories } from '../types'

const category: AppCategories = 'user'

export const sessionAdapter = {
    login: (credentials: UserCredentials): AppRequestType<UserAuth>['thirdParty']['login'] => ({
        endpoint: webApiEndpoints['thirdParty'].login,
        input: ({
            clientID: 'portal-swagger',
            password: credentials.password,
            username: credentials.user
        }),
        isSuccesful: response => !!response.data.token,
        output: (data) => ({
            token: secureHelper.encriptApiRequest(data.token, process.env.REACT_APP_CYPHER || ''),
            user: credentials.user
        })
    }),
    userMenu: (): AppRequestType<UserAccessType>[typeof category]['getUserMenu'] => ({
        endpoint: webApiEndpoints[category].getUserMenu,
        input: null,
        keepCacheBeforeNewRequest: true,
        output: (datos) => {
            let result: UserAccessType = {
                id: datos.id,
                rol: datos.rol,
                afore: datos.afore,
                notificationsUnread: datos.notificacionesPendientes,
                name: datos.nombre,
                menu: datos.menu.map(i => mapper.apiMenu(i)),
                credentials: datos.credenciales?.map(mapper.apiCredentials),
                credentialsJira: datos.credencialesTableros?.map(mapper.apiCredentialsJira),
                catalogApp: mapper.apiCatalogRoot(datos.catalogosApp),
                sdk: datos.sdk?.map(mapper.apiRepository),
                roles: datos.roles?.map(mapper.apiRol),
                soap: datos.soap?.reduce((prev, currentVal) => [...prev, ...mapper.apiResourceList(currentVal)], [] as ResourceType[]).filter(r => !!r.versions?.[0]),
                rest: datos.rest?.reduce((prev, currentVal) => [...prev, ...mapper.apiResourceList(currentVal)], [] as ResourceType[]).filter(r => !!r.versions?.[0]),
                linkedResources: datos.recursosVinculados?.map(mapper.apiResource).filter(r => !!r.versions?.[0]),
                particularData: (datos.datosParticulares || []).map(mapper.apiUserInfo).sort((a, b) => a.order - b.order),
                genericCatalog: mapper.apiCatalogGeneric(datos.catalogosGenericos)
            }
            return result
        }
    }),

    getNotifications: (items: number): AppRequestType<UserNotification[]>[typeof category]['getNotifications'] => ({
        endpoint: webApiEndpoints[category].getNotifications,
        input: ({ elementos: items }),
        keepCacheBeforeNewRequest: true,
        output: (datos) => datos.map(mapper.apiNotifications)
    }),

    updateNotification: (idNotification: string): AppRequestType<number>[typeof category]['updateNotification'] => ({
        endpoint: webApiEndpoints[category].updateNotification,
        input: ({ id: idNotification }),
        hideError: true,
        output: (datos) => datos
    }),

    updateAllNotification: (): AppRequestType<number>[typeof category]['updateAllNotification'] => ({
        endpoint: webApiEndpoints[category].updateAllNotification,
        input: null,
        output: (datos) => datos
    }),

    subscribeNotification: (idUser: number, token: string): AppRequestType<number>[typeof category]['subscribePushNotification'] => {
        let navigator = util.getNavigatorData()
        return {
            endpoint: webApiEndpoints[category].subscribePushNotification,
            input: ({
                idUsuario: idUser,
                token,
                navegador: `${navigator.name} ${navigator.version}`
            }),
            hideError: true,
            output: (datos) => datos
        }
    }
}